import { motion } from 'framer-motion'
import { MapPin, Search } from 'lucide-react'
import { Link } from 'react-router-dom'
import { buttonVariants } from './ui/button'
import { BrandMark } from './BrandMark'
import { ThemeToggle } from './ThemeToggle'

const Hero = () => {
  return (
    <div className="relative bg-background overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-gradient-to-r from-primary/10 to-accent/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16 sm:pt-24 sm:pb-20">
        {/* Navigation */}
        <motion.nav
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center justify-between mb-16"
        >
          <BrandMark />
          <div className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-muted-foreground hover:text-foreground transition-colors">Features</a>
            <a href="#how-it-works" className="text-muted-foreground hover:text-foreground transition-colors">How it works</a>
            <ThemeToggle />
            <Link to="/enter" className={buttonVariants({ size: 'lg' })}>Get Started</Link>
          </div>
        </motion.nav>

        <div className="text-center">
          {/* Hero content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            <h1 className="text-4xl sm:text-6xl lg:text-7xl font-bold text-foreground mb-6">
              Local services,{' '}
              <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                simplified
              </span>
            </h1>
            <p className="text-xl sm:text-2xl text-muted-foreground mb-8 max-w-3xl mx-auto my-8">
              Connect with trusted local service providers in your area. From movers to tutors,
              find, book, and coordinate services with ease.
            </p>
          </motion.div>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-16"
          >
            <Link to="/customer" className={buttonVariants({ size: 'lg', className: 'h-12 px-8 text-base gap-2' })}>
              <Search className="size-5" />
              <span>Find Services</span>
            </Link>
            <Link to="/provider" className={buttonVariants({ variant: 'outline', size: 'lg', className: 'h-12 px-8 text-base gap-2' })}>
              <MapPin className="size-5" />
              <span>Offer Services</span>
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default Hero
